import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      overflow: 'auto',

      '&:last-child': {
        paddingBottom: theme.spacing(2),
      },
    },
  };
};
